import React from 'react';
import { processSteps } from '../data/mock';

const Process = () => {
  return (
    <section className="process-modern">
      <div className="container-modern">
        <div className="section-header-modern centered">
          <span className="section-label-modern">OUR PROCESS</span>
          <h2 className="section-title-modern">From Design to Delivery</h2>
        </div>
        
        <div className="process-horizontal">
          {processSteps.map((step, idx) => (
            <div key={step.id} className="process-step-modern">
              <div className="process-step-number">{step.number}</div>
              <h3 className="process-step-title">{step.title}</h3>
              <p className="process-step-description">{step.description}</p>
              {idx < processSteps.length - 1 && (
                <div className="process-arrow">→</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
